document.addEventListener('DOMContentLoaded', function () {
    const profil = document.getElementById('profil');
    const particulier = document.querySelector('.cf7-particulier');
    const professionnel = document.querySelector('.cf7-professionnel');

    if (!profil) return;

    function toggleChamps() {
        const valeur = profil.value;

        particulier.classList.remove('visible');
        professionnel.classList.remove('visible');

        particulier.querySelectorAll('input, select, textarea').forEach(el => {
            el.disabled = valeur !== 'Un particulier';
        });
        professionnel.querySelectorAll('input, select, textarea').forEach(el => {
            el.disabled = valeur !== 'Un professionnel';
        });

        if (valeur === 'Un particulier') {
            particulier.classList.add('visible');
        } else if (valeur === 'Un professionnel') {
            professionnel.classList.add('visible');
        }
    }

    profil.addEventListener('change', toggleChamps);
    toggleChamps();
});
